import BaseDataService from './BaseDataService';
import { BaseDataServiceInterface } from './interface';

/**
 * Фабрика сервиса загрузки базовых данных для расчета маршрутов
 */
export const baseDataLoader: { (): BaseDataServiceInterface } = () => new BaseDataService();
